module.exports = __webpack_public_path__ + "img/succese.1766306608134.png";